import React, { useEffect, useState } from "react";
import { Button, Card, DatePicker, Input, Select, Skeleton, Spin } from "antd";
// import {
//   useGetFlowSectionMasterDataQuery,
//   useGetFlowConverterDetailsQuery,  jjhbhipjipi
//   useGetFlowSteamGropeMeterDetailsQuery,
//   useGetsteamMeterStatusDetailsQuery,
//   useNSGetFlowConverterDetailsQuery,
// } from "../../../../services/steam/LiveModule/LiveTrendsAPI";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
// import { useGetFlowGroupDetailsQuery } from "../../../../services/config_layout/group";

// import errorNew from "../../../../assets/error/error.png";   

import { calculateDateRangeFromDate } from "../../../../../../Utils//DateConverstion";

import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import MeterGrid from "../../../../../Elements/Grid/MeterGrid";
import { useSelector } from "react-redux";
import SteamTreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";




const { Option } = Select;
const { RangePicker } = DatePicker;

const SteamMeterStatus = () => {

  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [open, setOpen] = useState(false);
  const [sectionId, setSectionId] = useState(null);
  const [converterGroupId, setConverterGroupId] = useState(null);
  const [report, setReport] = useState(null);
  const [skip, setSkip] = useState(true);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();

  const [submitClicked, setSubmitClicked] = useState(false);

  const [input, setInput] = useState(null);
  const [flowSectionList, setFlowSectionList] = useState([])
  const [flowConverterList, setFlowConverterList] = useState([])
  const [flowGroupDetailList, setFlowGroupDetailList] = useState([])
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
  const [steamGroupMeterList, setSteamGroupMeterList] = useState([]);
  const [steamMeterData, setSteamMeterData] = useState([]);

  const [isLoading, setIsLoading] = useState(true)
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };


  const fetchSteamMeterLive = (input) => {
    const url = `${APIConstants.GET_STEAM_METER_STATUS_DETAILS}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
    }).then((res) => {
      setSteamMeterData(res);
      setIsLoading(false)
      console.log(res);
    });
  };
 


  useEffect(() => {
    if (input) {
      fetchSteamMeterLive(input);
    }
  }, [input]);

  //to fetch meter upon converter selection 
  const fetchNsFlow = (id) => {
    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${id}`
    }).then((res) => {
      console.log(res)
      setNsFlowConverterList(res);
    });
  };


  useEffect(() => {
    if (converterGroupId) {
      fetchNsFlow(converterGroupId);
    }
  }, [converterGroupId]);



  //to fetch metrs upon group selection
  const fetchGroupMeter = (id) => {

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${id}`
    }).then((res) => {
      console.log(res)
      setSteamGroupMeterList(res);
    });
  };


  useEffect(() => {
    if (converterGroupId) {
      fetchGroupMeter(converterGroupId);
    }
  }, [converterGroupId]);


  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
    }).then((res) => {
      console.log(res)
      setFlowSectionList(res);
    });

    makeRequest({
      type: APIConstants.GET,

      url: APIConstants.GET_FLOW_CONVERTER_DETAILS,
    }).then((res) => {
      console.log(res)
      setFlowConverterList(res);
    });

    makeRequest({
      type: APIConstants.GET,

      url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
    }).then((res) => {
      console.log(res)
      setFlowGroupDetailList(res);
    });

  }, [])


  const inputData = {
    SectionID: 1,
    ConverterorGroupID: 1,
    MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  }


  const handleChangeSection = (changedValues) => {
    setReport([])
    setSectionId(changedValues);
    setSelectedMeterIds();
    setConverterGroupId(null);
    setSubmitClicked(false)
    if (changedValues) {
      setSectionError("");
    }
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // // Clear the timeout if the component unmounts or skipValue is set to false jbjh nbbvjkghk khi7t llknnnkjnjknjn bnl kjih  jjnjnj jnkjj    ml     cx  xcvcv 
    return () => clearTimeout(timeoutId);
  }, []);


  const handleChangeConverterGroup = (changedValues) => {
    setReport([])
    setConverterGroupId(changedValues);
    setSubmitClicked(false)
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (!selectedValues.length) {
      setSubmitClicked(false)
    }
    if (selectedValues) {
      setMeterError("");
    }
  };

  const setInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");
    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);

    const inputData = {
      SectionID: Number(sectionId),
      ConverterorGroupID: Number(converterGroupId),
      MeterIds: ids,
      FromDate: from,
      ToDate: to,
    };

    const queryString = (inputData);
    setInput(queryString);
  };

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = async () => {

    setSubmitClicked(true)
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);

    if (!sectionError && !converterError && !meterError) {
      setInputData();
      onClose()
    }
  };

  useEffect(() => {
    if (steamMeterData?.length) {
      const selectedMeterData = steamMeterData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item.meterid)
      );
      setReport(selectedMeterData);
    }
  }, [steamMeterData]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (submitClicked && converterGroupId && sectionId && selectedMeterIds?.length) {
        setInputData();
      }
    }, 500000)
    return () => clearInterval(timer);
  }, [converterGroupId, sectionId, selectedMeterIds, submitClicked])


  console.log(report)


  return (
    <div className="relative" >
     <p className={` pb-2 text-xl ml-3 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>METER STATUS</p>
  
  {isLoading && (
    <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-10 dark:bg-opacity-10 z-50">
    
      <Spin size="large" />
    </div>
  )}
  
    <MeterGrid report={report} />

  

    
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        className={`  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}

      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">{sectionError}</small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? flowConverterList : flowGroupDetailList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">{converterError}</small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsFlowConverterList
                : steamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterID"}
            valueKey={sectionId === 1 ? "meterid" : "meterID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />

          <small className="text-red-500 font-bold ml-[150px]">{meterError}</small>


        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default SteamMeterStatus;
